'use client';

import { c as _c } from "react/compiler-runtime";
import { FooterCompact } from 'design-system/client';
import { useLocale, useTranslations } from 'next-intl';
import TextLink from '@/components/TextLink';
import { RailsRoutes } from '@/helpers/utils';
import type { Maybe } from '@/types';
function Footer(t0) {
  const $ = _c(18);
  const {
    ultimatelySubjectToLevy
  } = t0;
  const t = useTranslations("nextjs");
  const locale = useLocale();
  let t1;
  if ($[0] !== t) {
    t1 = t("footer.provider_info");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== locale) {
    t2 = RailsRoutes.imprint({
      locale
    });
    $[2] = locale;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("footer.impressum_label");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      href: t2,
      children: t3,
      external: true
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t || $[10] !== ultimatelySubjectToLevy) {
    t5 = ultimatelySubjectToLevy ? [{
      href: t("external_links.transaction_cost.url"),
      children: t("external_links.transaction_cost.content"),
      external: true,
      className: "larger-click-area"
    }, {
      href: t("external_links.a11y_statement.url"),
      children: t("external_links.a11y_statement.content"),
      external: true,
      className: "larger-click-area"
    }] : [];
    $[9] = t;
    $[10] = ultimatelySubjectToLevy;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = [t4, ...t5];
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t6) {
    t7 = <FooterCompact Link={TextLink} text={{
      providerInfo: t1,
      links: t6
    }} />;
    $[15] = t1;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
export default Footer;